<template>
    <div>
        <loading v-if="loading" size="small"></loading>
        <div v-else>
            <ul class="space-y-8 mb-16">
                <li>
                    <div class="flex items-center">
                        <checkbox v-model="filter.new">
                            <div class="flex items-center">
                                <progress-icon class="mr-8"></progress-icon>
                                <div>
                                    <span class="capitalize">{{ $t('general.new') }}</span>
                                </div>
                            </div>
                        </checkbox>
                    </div>
                </li>
                <li>
                    <div class="flex items-center">
                        <checkbox v-model="filter.hired">
                            <div class="flex items-center">
                                <progress-icon :progress="100" class="mr-8"></progress-icon>
                                <div>
                                    <span class="capitalize">{{ $t('analytics.hired') }}</span>
                                </div>
                            </div>
                        </checkbox>
                    </div>
                </li>
            </ul>
            <div class="pt-8 border-t border-primary-5">
                <h3 class="font-semibold text-body mb-8">{{ $t('applications.filters.specific_stages') }}</h3>
            </div>
            <simple-input v-model="search" :placeholder="$t('general.search') + '…'" class="mb-8"></simple-input>
            <div class="max-h-320 overflow-y-auto">
                <ul class="space-y-8">
                    <li
                        v-for="stage in stageList"
                        :key="'stage-' + stage.item.name"
                        :class="{ hidden: stage.score && stage.score > 0.5}"
                    >
                        <div class="flex items-center">
                            <checkbox
                                v-model="filter.stages"
                                :value="stage.item.name + ':' + stage.item.stages"
                            >
                                <span>{{ stage.item.name }}</span>
                            </checkbox>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import ProgressIcon from '../ui/ProgressIcon.vue';
import * as stages from '../../services/StageService';
import {mapState} from 'pinia';
import {useRepo} from 'pinia-orm';
import {useAuthenticationStore} from '../../state/modules/authentication';
import Loading from '../ui/Loading.vue';
import Checkbox from '../forms/Checkbox.vue';
import Input from '../forms/Input.vue';
import Fuse from 'fuse.js';
import SvgIcon from '../ui/SvgIcon.vue';
import * as dashboard from '../../services/DashboardService';
import * as RejectedReasonService from '../../services/RejectReasonService';
import RejectReason from '../../models/RejectReason';
import {normalizeJson} from '../../../shared/helpers';

export default {
    components: {
        SvgIcon,
        'progress-icon': ProgressIcon,
        'loading': Loading,
        'checkbox': Checkbox,
        'simple-input': Input,
    },
    props: {
        filter: Object,
    },
    data: function () {
        return {
            fuse: null,
            stages: [],
            search: '',
            loading: true,
            selectedStages: [],
            selectedReasons: [],
        };
    },
    computed: {
        ...mapState(useAuthenticationStore, ['currentCompanyId']),
        stageList() {
            return this.search.trim() === ''
                ? this.unfilteredStages
                : this.filteredStages;
        },
        filteredStages() {
            return this.fuse ? this.fuse.search(this.search.trim()) : [];
        },
        unfilteredStages() {
            return this.stages.map(stage => ({item: stage}));
        },
        reasons() {
            return useRepo(RejectReason).orderBy('order').get().map(item => ({
                label: item.title,
                value: item.id,
            }));
        },
        hasSelectedReasons() {
            if(!this.filter.rejected){
                return;
            }

            return this.reasons.some(item => this.filter.rejected.includes(item.value));
        },
        hasSelectedItems() {
            return this.hasSelectedReasons || this.filter.rejected.includes('all');
        },
    },
    methods: {
        setSelection(value, type = 0) {
            this.filter.rejected = this.filter.rejected.filter(obj => type ? obj === 'all' : obj !== 'all');
        },
    },
    mounted() {
        Promise.all([
            stages.index(this.currentCompanyId, false).then(result => {
                this.stages = result.stages.filter(stage => stage.order > 0 && !stage.onboarding);
                this.fuse = new Fuse(this.stages, {
                    keys: ['name'],
                    threshold: 1,
                    includeScore: true,
                });
            }),
            RejectedReasonService.index().then(({data}) => {
                useRepo(RejectReason).save(normalizeJson(data));
            }),
        ]).then(() => {
            this.loading = false;
        });
    },
};
</script>
